import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthFacade } from '@fy-web-2/state-auth';

/**
 * Route guard. Redirects unauthenticated users to `/login` and preserves the
 * intended destination via the `redirect` query param.
 */
export const authGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const facade = inject(AuthFacade);
  const router = inject(Router);

  if (facade.isAuthenticated()) return true;

  return router.createUrlTree(['/login'], {
    queryParams: { redirect: state.url },
  });
};
